// Generated by purs version 0.15.0
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Boolean from "../Data.Boolean/index.js";
import * as Data_Bounded from "../Data.Bounded/index.js";
import * as Data_Date from "../Data.Date/index.js";
import * as Data_Date_Component from "../Data.Date.Component/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Enum from "../Data.Enum/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_EuclideanRing from "../Data.EuclideanRing/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_HeytingAlgebra from "../Data.HeytingAlgebra/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Monoid_Extra from "../Data.Monoid.Extra/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Numeric from "../Data.Numeric/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
import * as Data_Time from "../Data.Time/index.js";
import * as Data_Time_Component from "../Data.Time.Component/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Common_Translations_Keys from "../Restaumatic.Common.Translations.Keys/index.js";
import * as Restaumatic_I18n from "../Restaumatic.I18n/index.js";
import * as Unscramble from "../Unscramble/index.js";
var SecondsOfDay = function (x) {
    return x;
};
var SecondOfDayRange = function (x) {
    return x;
};
var DailyAvailability = function (x) {
    return x;
};
var WeeklyAvailability = function (x) {
    return x;
};
var Available = /* #__PURE__ */ (function () {
    function Available() {

    };
    Available.value = new Available();
    return Available;
})();
var NotAvailableWholeDay = /* #__PURE__ */ (function () {
    function NotAvailableWholeDay() {

    };
    NotAvailableWholeDay.value = new NotAvailableWholeDay();
    return NotAvailableWholeDay;
})();
var NotAvailableAtTheTime = /* #__PURE__ */ (function () {
    function NotAvailableAtTheTime(value0) {
        this.value0 = value0;
    };
    NotAvailableAtTheTime.create = function (value0) {
        return new NotAvailableAtTheTime(value0);
    };
    return NotAvailableAtTheTime;
})();
var newtypeWeeklyAvailability = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeSecondsOfDay_ = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeSecondOfDayRange_ = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeDailyAvailability_ = {
    Coercible0: function () {
        return undefined;
    }
};
var genericWeeklyAvailability = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var genericSecondsOfDay_ = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var genericSecondOfDayRange_ = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var genericDailyAvailability_ = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var genericAvailabilityStatus = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return Available.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return NotAvailableWholeDay.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inr) {
            return new NotAvailableAtTheTime(x.value0.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.Calendar.Types.Availability (line 202, column 1 - line 202, column 45): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof Available) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof NotAvailableWholeDay) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof NotAvailableAtTheTime) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0));
        };
        throw new Error("Failed pattern match at Restaumatic.Calendar.Types.Availability (line 202, column 1 - line 202, column 45): " + [ x.constructor.name ]);
    }
};
var eqSecondsOfDay = {
    eq: function (x) {
        return function (y) {
            return x === y;
        };
    }
};
var ordSecondsOfDay = {
    compare: function (x) {
        return function (y) {
            return Data_Ord.compare(Data_Ord.ordInt)(x)(y);
        };
    },
    Eq0: function () {
        return eqSecondsOfDay;
    }
};
var eqSecondOfDayRange = {
    eq: function (x) {
        return function (y) {
            return Data_Eq.eq(eqSecondsOfDay)(x.from)(y.from) && Data_Eq.eq(eqSecondsOfDay)(x.to)(y.to);
        };
    }
};
var eqDailyAvailability = /* #__PURE__ */ Data_Eq.eqArray(eqSecondOfDayRange);
var eqWeeklyAvailability = {
    eq: function (x) {
        return function (y) {
            return Data_Eq.eq(eqDailyAvailability)(x.friday)(y.friday) && Data_Eq.eq(eqDailyAvailability)(x.monday)(y.monday) && Data_Eq.eq(eqDailyAvailability)(x.saturday)(y.saturday) && Data_Eq.eq(eqDailyAvailability)(x.sunday)(y.sunday) && Data_Eq.eq(eqDailyAvailability)(x.thursday)(y.thursday) && Data_Eq.eq(eqDailyAvailability)(x.tuesday)(y.tuesday) && Data_Eq.eq(eqDailyAvailability)(x.wednesday)(y.wednesday);
        };
    }
};
var eqAvailabilityStatus = {
    eq: function (x) {
        return function (y) {
            if (x instanceof Available && y instanceof Available) {
                return true;
            };
            if (x instanceof NotAvailableWholeDay && y instanceof NotAvailableWholeDay) {
                return true;
            };
            if (x instanceof NotAvailableAtTheTime && y instanceof NotAvailableAtTheTime) {
                return Data_Eq.eq(eqDailyAvailability)(x.value0)(y.value0);
            };
            return false;
        };
    }
};
var encodeSecondsOfDay = Foreign_Generic_Class.intEncode;
var encodeSecondOfDayRange = /* #__PURE__ */ Foreign_Generic_Class.recordEncode()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
    reflectSymbol: function () {
        return "to";
    }
})(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(encodeSecondsOfDay)))({
    reflectSymbol: function () {
        return "from";
    }
})(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(encodeSecondsOfDay)));
var encodeDailyAvailability = /* #__PURE__ */ Foreign_Generic_Class.arrayEncode(encodeSecondOfDayRange);
var encodeWeeklyAvailability = /* #__PURE__ */ Foreign_Generic_Class.recordEncode()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
    reflectSymbol: function () {
        return "wednesday";
    }
})(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(encodeDailyAvailability)))({
    reflectSymbol: function () {
        return "tuesday";
    }
})(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(encodeDailyAvailability)))({
    reflectSymbol: function () {
        return "thursday";
    }
})(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(encodeDailyAvailability)))({
    reflectSymbol: function () {
        return "sunday";
    }
})(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(encodeDailyAvailability)))({
    reflectSymbol: function () {
        return "saturday";
    }
})(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(encodeDailyAvailability)))({
    reflectSymbol: function () {
        return "monday";
    }
})(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(encodeDailyAvailability)))({
    reflectSymbol: function () {
        return "friday";
    }
})(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(encodeDailyAvailability)));
var decodeSecondsOfDay = Unscramble.decodeInt1;
var decodeSecondsOfDay1 = Foreign_Generic_Class.intDecode;
var decodeSecondOfDayRange = /* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons({
    reflectSymbol: function () {
        return "from";
    }
})(decodeSecondsOfDay)(/* #__PURE__ */ Unscramble.decodeRecordCons({
    reflectSymbol: function () {
        return "to";
    }
})(decodeSecondsOfDay)(Unscramble.decodeRecordNil)));
var decodeSecondOfDayRange1 = /* #__PURE__ */ Foreign_Generic_Class.recordDecode()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
    reflectSymbol: function () {
        return "to";
    }
})(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(decodeSecondsOfDay1))())({
    reflectSymbol: function () {
        return "from";
    }
})(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(decodeSecondsOfDay1))());
var decodeDailyAvailability = /* #__PURE__ */ Unscramble.decodeArray1(decodeSecondOfDayRange);
var decodeWeeklyAvailability = /* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons({
    reflectSymbol: function () {
        return "friday";
    }
})(decodeDailyAvailability)(/* #__PURE__ */ Unscramble.decodeRecordCons({
    reflectSymbol: function () {
        return "monday";
    }
})(decodeDailyAvailability)(/* #__PURE__ */ Unscramble.decodeRecordCons({
    reflectSymbol: function () {
        return "saturday";
    }
})(decodeDailyAvailability)(/* #__PURE__ */ Unscramble.decodeRecordCons({
    reflectSymbol: function () {
        return "sunday";
    }
})(decodeDailyAvailability)(/* #__PURE__ */ Unscramble.decodeRecordCons({
    reflectSymbol: function () {
        return "thursday";
    }
})(decodeDailyAvailability)(/* #__PURE__ */ Unscramble.decodeRecordCons({
    reflectSymbol: function () {
        return "tuesday";
    }
})(decodeDailyAvailability)(/* #__PURE__ */ Unscramble.decodeRecordCons({
    reflectSymbol: function () {
        return "wednesday";
    }
})(decodeDailyAvailability)(Unscramble.decodeRecordNil))))))));
var decodeDailyAvailability1 = /* #__PURE__ */ Foreign_Generic_Class.arrayDecode(decodeSecondOfDayRange1);
var decodeWeeklyAvailability1 = /* #__PURE__ */ Foreign_Generic_Class.recordDecode()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
    reflectSymbol: function () {
        return "wednesday";
    }
})(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(decodeDailyAvailability1))())({
    reflectSymbol: function () {
        return "tuesday";
    }
})(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(decodeDailyAvailability1))())({
    reflectSymbol: function () {
        return "thursday";
    }
})(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(decodeDailyAvailability1))())({
    reflectSymbol: function () {
        return "sunday";
    }
})(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(decodeDailyAvailability1))())({
    reflectSymbol: function () {
        return "saturday";
    }
})(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(decodeDailyAvailability1))())({
    reflectSymbol: function () {
        return "monday";
    }
})(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(decodeDailyAvailability1))())({
    reflectSymbol: function () {
        return "friday";
    }
})(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(decodeDailyAvailability1))());
var timeToSecondsOfDay = function (time) {
    return Data_Numeric.add(Data_Numeric.additiveInt)(Data_Numeric.add(Data_Numeric.additiveInt)(Data_Enum.fromEnum(Data_Time_Component.boundedEnumHour)(Data_Time.hour(time)) * 3600 | 0)(Data_Enum.fromEnum(Data_Time_Component.boundedEnumMinute)(Data_Time.minute(time)) * 60 | 0))(Data_Enum.fromEnum(Data_Time_Component.boundedEnumSecond)(Data_Time.second(time)));
};
var secondsToTimeShort = function (v) {
    var prefixZero = function (y) {
        var $120 = y > 9;
        if ($120) {
            return "";
        };
        return "0";
    };
    var minute = Data_EuclideanRing.div(Data_EuclideanRing.euclideanRingInt)(Data_EuclideanRing.mod(Data_EuclideanRing.euclideanRingInt)(v)(3600))(60);
    var minutes = prefixZero(minute) + Data_Show.show(Data_Show.showInt)(minute);
    var hour = (function () {
        var $121 = Data_EuclideanRing.div(Data_EuclideanRing.euclideanRingInt)(v)(3600) === 24;
        if ($121) {
            return 24;
        };
        return Data_EuclideanRing.mod(Data_EuclideanRing.euclideanRingInt)(Data_EuclideanRing.div(Data_EuclideanRing.euclideanRingInt)(v)(3600))(24);
    })();
    var hours = prefixZero(hour) + Data_Show.show(Data_Show.showInt)(hour);
    return hours + (":" + minutes);
};
var secondsToTime = function (v) {
    var second = Data_EuclideanRing.mod(Data_EuclideanRing.euclideanRingInt)(v)(60);
    var prefixZero = function (y) {
        var $123 = y > 9;
        if ($123) {
            return "";
        };
        return "0";
    };
    var seconds = prefixZero(second) + Data_Show.show(Data_Show.showInt)(second);
    var minute = Data_EuclideanRing.div(Data_EuclideanRing.euclideanRingInt)(Data_EuclideanRing.mod(Data_EuclideanRing.euclideanRingInt)(v)(3600))(60);
    var minutes = prefixZero(minute) + Data_Show.show(Data_Show.showInt)(minute);
    var hour = Data_EuclideanRing.div(Data_EuclideanRing.euclideanRingInt)(v)(3600);
    var hours = prefixZero(hour) + Data_Show.show(Data_Show.showInt)(hour);
    return hours + (":" + (minutes + Data_Monoid_Extra.mwhen(Data_Monoid.monoidString)(second !== 0)(":" + seconds)));
};
var editAsStringSecondsOfDay = {
    toString: secondsToTime,
    parse: function (str) {
        var fromHMS = function (v) {
            return function (v1) {
                return function (v2) {
                    var v3 = function (v4) {
                        var v5 = function (v6) {
                            return Data_Maybe.Nothing.value;
                        };
                        var $127 = v === 24;
                        if ($127) {
                            var $128 = v1 === 0;
                            if ($128) {
                                var $129 = v2 === 0;
                                if ($129) {
                                    return new Data_Maybe.Just(Data_Numeric.add(Data_Numeric.additiveInt)(Data_Numeric.add(Data_Numeric.additiveInt)(3600 * v | 0)(60 * v1 | 0))(v2));
                                };
                                return v5(true);
                            };
                            return v5(true);
                        };
                        return v5(true);
                    };
                    var $133 = v >= 0;
                    if ($133) {
                        var $134 = v <= 23;
                        if ($134) {
                            var $135 = v1 >= 0;
                            if ($135) {
                                var $136 = v1 < 60;
                                if ($136) {
                                    var $137 = v2 >= 0;
                                    if ($137) {
                                        var $138 = v2 < 60;
                                        if ($138) {
                                            return new Data_Maybe.Just(Data_Numeric.add(Data_Numeric.additiveInt)(Data_Numeric.add(Data_Numeric.additiveInt)(3600 * v | 0)(60 * v1 | 0))(v2));
                                        };
                                        return v3(true);
                                    };
                                    return v3(true);
                                };
                                return v3(true);
                            };
                            return v3(true);
                        };
                        return v3(true);
                    };
                    return v3(true);
                };
            };
        };
        var err = Restaumatic_I18n.translate_(Restaumatic_Common_Translations_Keys.t.form.errors.invalid_secondsofday);
        return Data_Either.note(err)(Control_Bind.join(Data_Maybe.bindMaybe)((function () {
            var v = Data_String_Common.split(":")(str);
            if (v.length === 3) {
                return Control_Apply.apply(Data_Maybe.applyMaybe)(Control_Apply.apply(Data_Maybe.applyMaybe)(Data_Functor.map(Data_Maybe.functorMaybe)(fromHMS)(Data_Int.fromString(v[0])))(Data_Int.fromString(v[1])))(Data_Int.fromString(v[2]));
            };
            if (v.length === 2) {
                return Control_Apply.apply(Data_Maybe.applyMaybe)(Control_Apply.apply(Data_Maybe.applyMaybe)(Data_Functor.map(Data_Maybe.functorMaybe)(fromHMS)(Data_Int.fromString(v[0])))(Data_Int.fromString(v[1])))(Control_Applicative.pure(Data_Maybe.applicativeMaybe)(0));
            };
            return Data_Maybe.Nothing.value;
        })()));
    }
};
var showSecondsOfDay = {
    show: secondsToTime
};
var showSecondOfDayRange = /* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "from";
    }
})(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "to";
    }
})(Data_Show.showRecordFieldsNil)(showSecondsOfDay))(showSecondsOfDay));
var showDailyAvailability = /* #__PURE__ */ Data_Show.showArray(showSecondOfDayRange);
var showAvailabilityStatus = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericAvailabilityStatus)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "Available";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "NotAvailableWholeDay";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(showDailyAvailability))({
        reflectSymbol: function () {
            return "NotAvailableAtTheTime";
        }
    }))))
};
var showWeeklyAvailability = /* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "friday";
    }
})(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "monday";
    }
})(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "saturday";
    }
})(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "sunday";
    }
})(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "thursday";
    }
})(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "tuesday";
    }
})(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "wednesday";
    }
})(Data_Show.showRecordFieldsNil)(showDailyAvailability))(showDailyAvailability))(showDailyAvailability))(showDailyAvailability))(showDailyAvailability))(showDailyAvailability))(showDailyAvailability));
var ranges = function (v) {
    return v;
};
var overWeeklyAvailability = /* #__PURE__ */ Data_Newtype.over()()(WeeklyAvailability);
var none = [  ];
var noneWeek = {
    monday: none,
    tuesday: none,
    wednesday: none,
    thursday: none,
    friday: none,
    saturday: none,
    sunday: none
};
var mkRange = function (from) {
    return function (to) {
        return {
            from: from,
            to: to
        };
    };
};
var isRangeStartAfter = function (v) {
    return function (seconds) {
        return Data_Ord.lessThanOrEq(ordSecondsOfDay)(seconds)(v.from);
    };
};
var isInRange = function (v) {
    return function (seconds) {
        return Data_Ord.greaterThanOrEq(ordSecondsOfDay)(seconds)(v.from) && Data_Ord.lessThan(ordSecondsOfDay)(seconds)(v.to);
    };
};
var getDailyAvailability = function (v) {
    return function (weekday) {
        if (weekday instanceof Data_Date_Component.Monday) {
            return v.monday;
        };
        if (weekday instanceof Data_Date_Component.Tuesday) {
            return v.tuesday;
        };
        if (weekday instanceof Data_Date_Component.Wednesday) {
            return v.wednesday;
        };
        if (weekday instanceof Data_Date_Component.Thursday) {
            return v.thursday;
        };
        if (weekday instanceof Data_Date_Component.Friday) {
            return v.friday;
        };
        if (weekday instanceof Data_Date_Component.Saturday) {
            return v.saturday;
        };
        if (weekday instanceof Data_Date_Component.Sunday) {
            return v.sunday;
        };
        throw new Error("Failed pattern match at Restaumatic.Calendar.Types.Availability (line 182, column 3 - line 189, column 23): " + [ weekday.constructor.name ]);
    };
};
var fromArrayStartOnSunday = function (v) {
    if (v.length === 7) {
        return new Data_Maybe.Just({
            sunday: v[0],
            monday: v[1],
            tuesday: v[2],
            wednesday: v[3],
            thursday: v[4],
            friday: v[5],
            saturday: v[6]
        });
    };
    return Data_Maybe.Nothing.value;
};
var formatDailyAvailability = function (v) {
    var showRange = function (v1) {
        return secondsToTimeShort(v1.from) + ("-" + secondsToTimeShort(v1.to));
    };
    return Data_Foldable.intercalate(Data_Foldable.foldableArray)(Data_Monoid.monoidString)(", ")(Data_Functor.map(Data_Functor.functorArray)(showRange)(v));
};
var dailyAvailabilityStatus = function (daily) {
    return function (time) {
        if (Data_Foldable.any(Data_Foldable.foldableArray)(Data_HeytingAlgebra.heytingAlgebraBoolean)(function (range) {
            return isInRange(range)(time);
        })(ranges(daily))) {
            return Available.value;
        };
        if (Data_Eq.eq(Data_Eq.eqArray(eqSecondOfDayRange))(ranges(daily))([  ])) {
            return NotAvailableWholeDay.value;
        };
        if (Data_Boolean.otherwise) {
            return new NotAvailableAtTheTime(daily);
        };
        throw new Error("Failed pattern match at Restaumatic.Calendar.Types.Availability (line 215, column 1 - line 215, column 83): " + [ daily.constructor.name, time.constructor.name ]);
    };
};
var circularPred = /* #__PURE__ */ (function () {
    var $191 = Data_Maybe.fromMaybe(Data_Bounded.top(Data_Date_Component.boundedWeekday));
    var $192 = Data_Enum.pred(Data_Date_Component.enumWeekday);
    return function ($193) {
        return $191($192($193));
    };
})();
var availableLaterOnThatDay = function (daily) {
    return function (time) {
        return Data_Foldable.any(Data_Foldable.foldableArray)(Data_HeytingAlgebra.heytingAlgebraBoolean)(function (range) {
            return isRangeStartAfter(range)(time);
        })(ranges(daily));
    };
};
var availabilityStatusOnWeekday = function (availability) {
    return function (weekday) {
        return function (time) {
            if (Data_Eq.eq(eqAvailabilityStatus)(dailyAvailabilityStatus(getDailyAvailability(availability)(circularPred(weekday)))(Data_Newtype.wrap()(Data_Numeric.add(Data_Numeric.additiveInt)(Data_Newtype.unwrap()(time))(86400))))(Available.value)) {
                return Available.value;
            };
            if (Data_Boolean.otherwise) {
                return dailyAvailabilityStatus(getDailyAvailability(availability)(weekday))(time);
            };
            throw new Error("Failed pattern match at Restaumatic.Calendar.Types.Availability (line 206, column 1 - line 206, column 99): " + [ availability.constructor.name, weekday.constructor.name, time.constructor.name ]);
        };
    };
};
var availabilityStatus = function (availability) {
    return function (v) {
        return availabilityStatusOnWeekday(availability)(Data_Date.weekday(v.value0))(timeToSecondsOfDay(v.value1));
    };
};
var isAvailable = function (availability) {
    return function (dt) {
        return Data_Eq.eq(eqAvailabilityStatus)(availabilityStatus(availability)(dt))(Available.value);
    };
};
var isAvailableNowOrLaterOnThatDay = function (availability) {
    return function (v) {
        var v1 = availabilityStatus(availability)(v);
        if (v1 instanceof NotAvailableAtTheTime) {
            return availableLaterOnThatDay(v1.value0)(timeToSecondsOfDay(v.value1));
        };
        if (v1 instanceof Available) {
            return true;
        };
        if (v1 instanceof NotAvailableWholeDay) {
            return false;
        };
        throw new Error("Failed pattern match at Restaumatic.Calendar.Types.Availability (line 245, column 3 - line 248, column 34): " + [ v1.constructor.name ]);
    };
};
var isAvailableOnThatDay = function (availability) {
    return function (dt) {
        return Data_Eq.notEq(eqAvailabilityStatus)(availabilityStatus(availability)(dt))(NotAvailableWholeDay.value);
    };
};
var isAvailableOnlyLaterOnThatDay = function (availability) {
    return function (v) {
        var v1 = availabilityStatus(availability)(v);
        if (v1 instanceof NotAvailableAtTheTime) {
            return availableLaterOnThatDay(v1.value0)(timeToSecondsOfDay(v.value1));
        };
        return false;
    };
};
var allDay = [ {
    from: /* #__PURE__ */ Data_Newtype.wrap()(0),
    to: /* #__PURE__ */ Data_Newtype.wrap()(86400)
} ];
var allWeek = {
    monday: allDay,
    tuesday: allDay,
    wednesday: allDay,
    thursday: allDay,
    friday: allDay,
    saturday: allDay,
    sunday: allDay
};
var availableWholeDay = function (daily) {
    return Data_Eq.eq(eqDailyAvailability)(daily)(allDay);
};
var isAvailableWholeDay = function (availability) {
    return function (v) {
        return availableWholeDay(getDailyAvailability(availability)(Data_Date.weekday(v.value0)));
    };
};
export {
    DailyAvailability,
    none,
    allDay,
    getDailyAvailability,
    SecondsOfDay,
    SecondOfDayRange,
    mkRange,
    isInRange,
    secondsToTimeShort,
    WeeklyAvailability,
    overWeeklyAvailability,
    allWeek,
    noneWeek,
    fromArrayStartOnSunday,
    Available,
    NotAvailableWholeDay,
    NotAvailableAtTheTime,
    isAvailable,
    isAvailableOnThatDay,
    isAvailableWholeDay,
    isAvailableOnlyLaterOnThatDay,
    isAvailableNowOrLaterOnThatDay,
    availabilityStatus,
    availabilityStatusOnWeekday,
    formatDailyAvailability,
    circularPred,
    genericSecondsOfDay_,
    newtypeSecondsOfDay_,
    eqSecondsOfDay,
    ordSecondsOfDay,
    showSecondsOfDay,
    decodeSecondsOfDay1,
    decodeSecondsOfDay,
    encodeSecondsOfDay,
    genericSecondOfDayRange_,
    newtypeSecondOfDayRange_,
    eqSecondOfDayRange,
    showSecondOfDayRange,
    decodeSecondOfDayRange1,
    decodeSecondOfDayRange,
    encodeSecondOfDayRange,
    editAsStringSecondsOfDay,
    newtypeDailyAvailability_,
    genericDailyAvailability_,
    showDailyAvailability,
    eqDailyAvailability,
    encodeDailyAvailability,
    decodeDailyAvailability1,
    decodeDailyAvailability,
    newtypeWeeklyAvailability,
    genericWeeklyAvailability,
    eqWeeklyAvailability,
    showWeeklyAvailability,
    decodeWeeklyAvailability1,
    decodeWeeklyAvailability,
    encodeWeeklyAvailability,
    eqAvailabilityStatus,
    genericAvailabilityStatus,
    showAvailabilityStatus
};
//# sourceMappingURL=index.js.map
